import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { CardHeader } from 'reactstrap';
import { Case, Else, If, Switch, Then, When } from 'react-if';
import { ReactComponent as EmailAllIcon } from './Email_all_icon.svg';
import * as QUESTION from '../../../../constants/questions';
import YesNoStatistic from './YesNoStatistic';
import MultipleStatistic from './MultipleStatistic';
import './styles.css';

const PostOwnerFooter = ({
    count,
    questionType,
    questions,
    postCategory,
    areReviewsOpen,
    onReviewsOpen,
    onInviteFriendsButtonClick,
    onEmailAllButtonClick,
}) => {
    const handleOpenReviewsButtonClick = useCallback(() => {
        if (count) {
            onReviewsOpen();
        }
    }, [count, onReviewsOpen]);

    return (
        <CardHeader className="post-footer">
            <div className="post-footer__container d-flex align-items-center">
                <div className="d-flex mx-3 flex">
                    <button
                        className="post__footer-button mr-4"
                        onClick={onInviteFriendsButtonClick}
                    >
                        + Invite friends
                    </button>
                    <When condition={!!count}>
                        <button className="post__footer-button" onClick={onEmailAllButtonClick}>
                            <EmailAllIcon />
                            <span className="ml-2">Email all</span>
                        </button>
                    </When>
                </div>
                <p
                    className="m-0 d-flex justify-content-center align-items-center cursor-pointer"
                    onClick={handleOpenReviewsButtonClick}
                >
                    <If condition={!!count}>
                        <Then>
                            <If condition={areReviewsOpen}>
                                <Then>
                                    <span className="d-flex align-items-center post__comments-text">
                                        <b className="mr-1">Close</b> {count} Comments
                                        <i className="material-icons">keyboard_arrow_up</i>
                                    </span>
                                </Then>
                                <Else>
                                    <span className="d-flex align-items-center post__comments-text">
                                        <b className="mr-1">Open</b> {count} Comment
                                        <When condition={count >= 2}>s</When>
                                        <i className="material-icons">keyboard_arrow_down</i>
                                    </span>
                                </Else>
                            </If>
                        </Then>
                        <Else>
                            <span className="post__comments-text">No comments</span>
                        </Else>
                    </If>
                </p>
                <div className="align-items-center d-flex justify-content-end flex mx-3">
                    <Switch>
                        <Case condition={questionType === QUESTION.YES_NO}>
                            <YesNoStatistic questions={questions} color={postCategory.color} />
                        </Case>
                        <Case condition={questionType === QUESTION.MULTIPLE}>
                            <MultipleStatistic questions={questions} color={postCategory.color} />
                        </Case>
                    </Switch>
                </div>
            </div>
        </CardHeader>
    );
};

PostOwnerFooter.propTypes = {
    areReviewsOpen: PropTypes.bool.isRequired,
    count: PropTypes.number.isRequired,
    questions: PropTypes.array.isRequired,
    questionType: PropTypes.number.isRequired,
    onEmailAllButtonClick: PropTypes.func.isRequired,
    onInviteFriendsButtonClick: PropTypes.func.isRequired,
    onReviewsOpen: PropTypes.func.isRequired,
};

export default React.memo(PostOwnerFooter);
